module.exports = ".tchead h6 {\n  font-size: 25px;\n  color: #212529;\n  text-align: left;\n  font-weight: 500; }\n\n.tcinnerhead h6 {\n  font-size: 20px;\n  color: #212529;\n  text-align: left; }\n\n.tcinnertext p {\n  font-size: 14px; }\n\n.farerule_dot {\n  height: 6px;\n  width: 6px;\n  background-color: #212529;\n  border-radius: 50%;\n  display: inline-block; }\n\n.container {\n  text-align: justify; }\n\n.tchead {\n  color: #212529 !important;\n  border-bottom: 1px solid #d24444 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/privacy-policy/privacy-policy.component.scss
// module id = ./src/app/privacy-policy/privacy-policy.component.scss
// module chunks = main